<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">学生管理</Breadcrumb-item>
        <Breadcrumb-item>停课学生列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
          <!-- <Col span="5">
             <Form-item label="注册时间：">
               <Date-picker  v-model="regDateRange" format="yyyy-MM-dd" type="daterange"
                             placement="bottom-start" placeholder="选择日期"
                             @on-change="regDateChange" style="width: 220px;"></Date-picker>
             </Form-item>
           </Col>-->
          <Col :span="6">
            <Form-item label="学导：">
              <admin-user-select :status="1" adminGroupCode="userStudyAdviser"
                                 v-model="queryParam.adminUserId"></admin-user-select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="课程顾问：">
              <admin-user-select :status="1" adminGroupCode="adviser"
                                 v-model="queryParam.adviserId"></admin-user-select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学员ID：">
              <Input name="uid" v-model="queryParam.uid" placeholder="不支持模糊搜索"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学生姓名：">
              <Input name="nickname" v-model="queryParam.nickname" placeholder="支持模糊搜索"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学生手机号：">
              <Input name="mobile" v-model="queryParam.mobile" placeholder="支持模糊搜索"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="停课原因：">
              <Input name="stopRemark" v-model="queryParam.stopRemark" placeholder="支持模糊搜索"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="预计复课时间：">
              <DatePicker @on-change="timeDateChange" format="yyyy-MM-dd" type="daterange" placement="bottom-start"
                          placeholder="选择起始时间" style="width: 100%"></DatePicker>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="停课时间：">
              <DatePicker @on-change="stopLessonTimeDateChange" format="yyyy-MM-dd" type="daterange"
                          placement="bottom-start" placeholder="选择起始时间" style="width: 100%"></DatePicker>
            </Form-item>
          </Col>
          <Col :span="2">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                    @click="search">搜索
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <div class="btn-wrap">
      <Row>
        <Col>
          <Button type="primary" @click="onAssignAdviser">解绑学导</Button>
          <Button type="primary" :loading="cancelLoading" :disable="cancelLoading" icon=""
                  @click="batchCancel">批量取消停课
          </Button>
          <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="search" v-perm="'601'"
                  @click="exportData">导出
          </Button>
          <Button type="primary" @click="onBatchCompletedCourses">批量结课</Button>
        </Col>
      </Row>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/user/lessonsStop/list"
          :params="queryParam" :onLoading="onLoading" @on-selection-change="selectionChange"></List>
    <UnBinStudyModals :successCallback="search" :userList="selectionUser"
                      v-model="showUnBinStudyModal"></UnBinStudyModals>
    <BatchCompletedCoursesModal :uidStr="uidStr" :successCallback="search"
                                v-model="showBatchCompletedCoursesModal"></BatchCompletedCoursesModal>
  </div>
</template>

<script>
import dates from '@/tools/date/dates.js'
import UnBinStudyModals from './UnBinStudyModals.vue'
import BatchCompletedCoursesModal from './BatchCompletedCoursesModal.vue'

export default {
  components: {
    BatchCompletedCoursesModal,
    UnBinStudyModals,
  },
  name: 'UserRefundList',
  data () {
    let $constant = this.$constant
    return {
      uidStr: '',
      searchLoading: false,
      showBatchCompletedCoursesModal: false,
      showUnBinStudyModal: false,
      reload: 0,
      timer: '',
      smsCode: '',
      time: 60,
      disabled: false,
      queryParam: {
        startTime: null,
        endTime: null,
        uid: '',
        adviserName: '',
        nickname: '',
        mobile: '',
        stopRemark: '',
        studyAdviserName: '',
        stdStatus: 10,
        adminUserId: '',
        adviserId: '',
        resumeLessonTimeStart: '',
        resumeLessonTimeEnd: '',
        stopLessonTimeStart: null,
        stopLessonTimeEnd: null
      },
      remark: '',
      cancelLoading: false,
      exportLoading: false,
      selectionUser: [],
      regDateRange: [],
      title: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '学生ID/姓名',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('span', row.id + '-' + row.nickname)
          }
        },
        {
          title: '手机号',
          width: 130,
          align: 'center',
          key: 'mobile',
          render: (h, params) => {
            return h('Poptip', {
              props: {
                trigger: 'hover'
              }
            }, [
              h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) +
                '****' + params.row.mobile.substring(7) : params.row.mobile),
              // 当前行展示的数据
              h('div', {slot: 'content'}, params.row.mobile)
            ])
          }
        },
        {
          title: '剩余课时',
          width: 160,
          align: 'center',
          key: 'availableClassHour'
        },
        {
          title: '学导',
          width: 130,
          align: 'center',
          key: 'studyAdviserName'
        },
        {
          title: '课程顾问',
          width: 130,
          align: 'center',
          key: 'adviserName'
        },
        {
          title: '注册渠道',
          width: 120,
          align: 'center',
          key: 'regType',
          // render: (h, params) => {
          //   let regType = params.row.regType
          //   let canalEnum = $constant.getEnum($constant.studentCanal, regType)
          //   return h('div', canalEnum && canalEnum.text)
          // }
        },
        {
          title: '注册时间',
          align: 'center',
          width: 170,
          key: 'gmtCreate',
        },
        {
          title: '停课时间',
          align: 'center',
          width: 170,
          key: 'stopLessonTime',
        },
        {
          title: '停课原因',
          align: 'center',
          width: 170,
          key: 'stopRemark',
        },
        {
          title: '预计复课时间',
          align: 'center',
          width: 170,
          key: 'resumeLessonTime'
        },
        {
          title: '等级',
          width: 120,
          align: 'center',
          key: 'levelTitle'
        },
        {
          title: '是否付款',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let isPay = params.row.isPay
            let isPayEnum = $constant.getEnum($constant.yesNoNum, isPay)
            return h('span', isPayEnum && isPayEnum.text)
          }
        },
        {
          title: '用户状态',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let status = params.row.status
            let statusEnum = $constant.getEnum($constant.userListStatus, status)
            return h('span', statusEnum && statusEnum.text)
          }
        },
        {
          title: '资源状态',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let resourceStatus = params.row.resourceStatus
            let resourceStatusEnum = $constant.getEnum($constant.resourceStatus, resourceStatus)
            return h('span', resourceStatusEnum && resourceStatusEnum.text)
          }
        },
        {
          title: '学生状态',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let studentStatus = params.row.studentStatus
            let studentStatusEnum = $constant.getEnum($constant.studentStatus, studentStatus)
            return h('span', studentStatusEnum && studentStatusEnum.text)
          }
        },
        {
          title: '学员状态',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let stdStatus = params.row.stdStatus
            let stdStatusEnum = $constant.getEnum($constant.stdStatus, stdStatus)
            return h('span', stdStatusEnum && stdStatusEnum.text)
          }
        }
      ]
    }
  },
  mounted: function () {
    this.init()
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      let query = this.$route.query
      if (query) {
        if (query.startTime) {
          this.regDateRange[0] = dates.format(parseInt(query.startTime) * 1000, 'YYYY-MM-DD') + ''
        }
        if (query.endTime) {
          this.regDateRange[1] = dates.format(parseInt(query.endTime) * 1000, 'YYYY-MM-DD') + ''
        }
        if (query.uid) {
          this.queryParam.uid = query.uid
        }
        if (query.adviserName) {
          this.queryParam.adviserName = query.adviserName
        }
        if (query.studyAdviserName) {
          this.queryParam.studyAdviserName = query.studyAdviserName
        }
        if (query.nickname) {
          this.queryParam.nickname = query.nickname
        }
        if (query.mobile) {
          this.queryParam.mobile = query.mobile
        }
      }
    },
    timeDateChange (value) {
      this.queryParam.resumeLessonTimeStart = value[0] && this.$moment(value[0], 'YYYY-M-D H:m').format('X')
      this.queryParam.resumeLessonTimeEnd = value[1] && this.$moment(value[1], 'YYYY-M-D H:m').format('X')
    },
    stopLessonTimeDateChange (value) {
      if (!value || !value[0] || !value[1]) {
        this.queryParam.stopLessonTimeStart = null
        this.queryParam.stopLessonTimeEnd = null
        return
      }
      this.queryParam.stopLessonTimeStart = value[0]
      this.queryParam.stopLessonTimeEnd = value[1]
    },
    onAssignAdviser () {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需要解绑的学生！')
        return
      }
      this.showUnBinStudyModal = true
    },
    search () {
      this.reload = new Date().getTime()
    },
    onLoading (loading) {
      this.searchLoading = loading
    },
    selectionChange (selection) {
      this.selectionUser = selection
    },
    exportData (type) {
      this.exportLoading = true
      this.$http.get('/user/stopClass/exportExcel', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '停课学生.csv'
          link.click()
          this.exportLoading = false
        } else {
          this.$Message.error(response.msg)
        }
      }).catch((e) => {
        this.exportLoading = false
      })
    },
    onBatchCompletedCourses () {
      let self = this
      if (self.selectionUser.length <= 0) {
        self.$Message.warning('请选择需学生！')
        return
      }
      let idList = self.selectionUser.map(function (element) {
        return element.id
      })
      self.uidStr = idList.join(';')
      self.showBatchCompletedCoursesModal = true
    },
    batchCancel () {
      let self = this
      this.cancelLoading = true
      let ids = []
      let user = null
      if (this.selectionUser && this.selectionUser.length > 0) {
        for (let i in this.selectionUser) {
          let dto = this.selectionUser[i]
          user = dto
          ids[i] = dto.id
        }
      } else {
        self.$Message.warning('请选择取消停课人')
        this.cancelLoading = false
        return
      }
      this.$Modal.confirm({
        title: '[' + user.id + '-' + user.nickname + ']' + '>>取消停课',
        width: 300,
        okText: '确定',
        loading: true,
        render: (h, params) => {
          return h('div', [
            h('Input', {
              props: {
                placeholder: '请输入复课原因'
              },
              on: {
                input: (e) => {
                  self.remark = e
                }
              }
            }),
            h('Button', {
              attrs: {disabled: self.disabled},
              on: {
                click: () => {
                  self.$http.get('/userinfo/sendUpdateMobileSmsCode', {params: {uid: user.id, key: 'call_back_from_stop_sms'}}).then(res => {
                    if (res.status === 'ok') {
                      self.disabled = true
                      self.$Message.success('验证码发送成功!')
                      self.timer = setInterval(() => {
                        if (self.time <= 0) {
                          self.disabled = false
                          self.time = 60
                          clearInterval(this.timer)
                        } else {
                          self.time -= 1
                        }
                      }, 1000)
                    }
                  })
                }
              }
            }, self.disabled ? (self.time + '秒') : '发送验证码'),
            h('Input', {
              props: {
                placeholder: '短信验证码'
              },
              on: {
                input: (e) => {
                  self.smsCode = e
                }
              }
            }),
          ])
        },
        onOk: () => {
          this.$http.post('/user/lessonsStop/batchCancelUserStopLesson', {
            ids: ids.join(','),
            remark: this.remark,
            isStop: 1,
            smsCode: this.smsCode
          }).then((res) => {
            if (res && res.data > 0) {
              self.$Message.success('移出申请已提交')
              self.cancelLoading = false
              self.search()
              self.$Modal.remove()
            } else {
              self.$Message.error('批量移出失败！')
              self.cancelLoading = false
              self.$Modal.remove()
            }
          }).catch((e) => {
            this.cancelLoading = false
          })
        },
        onCancel: () => {
          this.cancelLoading = false
          self.time = 60
          clearInterval(this.timer)
          self.disabled = false
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.btn-wrap {
  text-align: right;
  margin-top: 24px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// UserLessonsStopList.vue?127da86c